import * as React from 'react'
import { QueryClientProvider } from 'react-query'
import buildQueryClient from '../helpers/queryClient'
import ItemsOverview from "./ItemsOverview";

export default function ItemsOverviewApp({ items, lastUpdated }) {
  const queryClient = buildQueryClient()

  return (
    <QueryClientProvider client={queryClient}>
      <ItemsOverview items={items} lastUpdated={lastUpdated} />
    </QueryClientProvider>
  )
}
